interface DataObject<T> {
  [key: string]: T;
}

export const fromObjectDataToArrayData = <T extends number | string>(
  data: DataObject<T> | undefined,
): { value: T; label: string }[] =>
  data
    ? Object.entries(data).map(([label, value]) => ({
        value: value as T,
        label,
      }))
    : [];
